"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReactiveStore = exports.getFeatureFlags = exports.setFeatureFlags = void 0;
let reactiveStore;
const setFeatureFlags = (featureFlags) => {
    reactiveStore.data = featureFlags;
};
exports.setFeatureFlags = setFeatureFlags;
const setReactiveStore = (store) => {
    reactiveStore = store;
};
exports.setReactiveStore = setReactiveStore;
const getFeatureFlags = () => {
    return reactiveStore.data;
};
exports.getFeatureFlags = getFeatureFlags;
